import axios from "axios";
import * as actionType from "../../constant/actionType";
export const GetAllSpecificProviderWorkerInd = (getAllData,organisation_id) => async (dispatch) => {
  try {

    const response = await axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        
        organisationid: organisation_id,
      },
      url: `${actionType.environment_url}/api/admin/provider/GetSpecificProviderWorkerInd`,
      params: getAllData,
    });
    return response.data;
  } catch (error) {}
};